<div class="user-balances">
  <!--Points Balance-->
  <div class="bg-glass balance-widget">
    <div class="balance-details">
      <span class="icon material-symbols-outlined">loyalty</span>
      <div class="balance">
        <h5 class="mb-0">{{ pointsBalance$ | async | number : '1.0-0' }}</h5>
        <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
      </div>
    </div>
  </div>

  <!--eCash Balance-->
  <div class="bg-glass balance-widget cursor-pointer">
    <div class="balance-details">
      <span class="icon material-symbols-outlined money-bag-icon">money_bag</span>
      <div class="balance">
        <h5 class="mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</h5>
        <div class="font-size-12 me-1">{{ 'member.card.ecash.balance' | translate }}</div>
      </div>
    </div>
  </div>
</div>
